export default {
    enrollments() {
        return axios.get('/api/hpc/enrollments');
    }
};
